<template>
  <v-card>
    <v-card-title>
      <span class="headline">Add Inventory Form</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-model="description"
              label="Name of the Inventory Item"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-select
              v-model="demand"
              :items="items"
              :rules="[(v) => !!v || 'Item is required']"
              label="Demand"
              required
            ></v-select>
          </v-col>

          <v-col cols="6" sm="6" md="6">
            <v-text-field
              v-model="firstName"
              label="First Name"
              hint="Enter the First Name"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="6" md="6">
            <v-text-field
              v-model="lastName"
              label="Last Name"
              hint="Enter the Last Name"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="12" md="6">
            <date-picker :dateTimeStamp="date" />
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <time-picker :TimeStamp="time" />
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-model="phoneNumber"
              label="Phone Number"
              hint="Enter your Phone Number"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-model="address"
              label="Address"
              hint="Enter the Address of the location"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-autocomplete
              v-model="city"
              :items="cities"
              label="City"
              class="pointer"
              placeholder="Enter the City"
              append-icon="mdi-map-marker"
              auto-select-first
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-model="country"
              label="Country"
              hint="Enter the Country"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <div class="container upload-image-offset">
              <div class="row justify-content-center">
                <div class="col-12"><image-upload :title="upload" /></div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <small>*indicates required field</small>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="this.triggerCloseDialog">
        Close
      </v-btn>
      <v-btn color="blue darken-1" text @click="this.saveInventoryItem">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { eventBus } from "@/main.js";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import cities from "../shared/constants/cities";
import imageUpload from "../shared/components/imageUpload";
import datePicker from "../shared/components/datePicker";
import timePicker from "../shared/components/timePicker";
export default {
  async created() {
    this.populateFromCities();
  },
  computed: {
    ...mapFields("donation", ["donationCenterId"]),
    ...mapFields("shared", [
      "imagePath",
      "selectedTime",
      "selectedDate",
      "selectedDateTime",
    ]),
  },
  components: { imageUpload, datePicker, timePicker },
  data: () => ({
    date: null,
    time: null,
    demand: null,
    description: "",
    upload: null,
    city: "",
    cities: [],
    country: "",
    address: "",
    firstName: "",
    lastName: "",
    fullName: "",
    location: [],
    phoneNumber: "",
    items: ["High", "Medium", "Low"],
  }),
  methods: {
    ...mapActions("donation", ["addDonationInventoryItem"]),
    ...mapActions("shared", ["setImagePath", "dateTimeSelected"]),
    triggerCloseDialog(value) {
      eventBus.$emit("dialogToggle", false);
    },
    populateFromCities() {
      cities.map((city) => {
        this.cities.push(city.name);
      });
    },
    async saveInventoryItem() {
      // Parse string TimeDate as TimeStamp
      var dateTime = this.selectedDate + " " + this.selectedTime;
      this.dateTimeSelected({
        payload: {
          datetime: dateTime,
        },
      });
      var location = cities.find((element) => element.name === this.city);

      // extract only latitude and longitudes
      this.location.push({ lat: location.lat, long: location.lng });

      try {
        this.fullName = this.firstName + " " + this.lastName;
        this.addDonationInventoryItem({
          payload: {
            centerId: this.donationCenterId,
            inventory: {
              address: this.address,
              date: this.selectedDateTime,
              description: this.description,
              fullName: this.fullName,
              location: this.location,
              phoneNumber: this.phoneNumber,
              userId: "4a4XQvTTf8hmGclK3gH9pTSqtgg2", // static user id since No Users model
            },
          },
        });
        eventBus.$emit("dialogToggle", false);
        alert("Successfully Added Donation Inventory item!");
      } catch (error) {
        console("Failed to Add Donation Inventory item!", error);
      }
    },
  },
};
</script>